var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15175_56108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0C1.68164 0 0 1.68164 0 3.75V26.25C0 28.3184 1.68164 30 3.75 30H18.75C20.8184 30 22.5 28.3184 22.5 26.25V9.375H15C13.9629 9.375 13.125 8.53711 13.125 7.5V0H3.75ZM15 0V7.5H22.5L15 0ZM4.6875 3.75H8.4375C8.95312 3.75 9.375 4.17188 9.375 4.6875C9.375 5.20312 8.95312 5.625 8.4375 5.625H4.6875C4.17188 5.625 3.75 5.20312 3.75 4.6875C3.75 4.17188 4.17188 3.75 4.6875 3.75ZM4.6875 7.5H8.4375C8.95312 7.5 9.375 7.92188 9.375 8.4375C9.375 8.95312 8.95312 9.375 8.4375 9.375H4.6875C4.17188 9.375 3.75 8.95312 3.75 8.4375C3.75 7.92188 4.17188 7.5 4.6875 7.5ZM7.86328 22.3711C7.50586 23.5605 6.41016 24.375 5.16797 24.375H4.6875C4.17188 24.375 3.75 23.9531 3.75 23.4375C3.75 22.9219 4.17188 22.5 4.6875 22.5H5.16797C5.58398 22.5 5.94727 22.2305 6.06445 21.832L6.9375 18.9316C7.13672 18.2695 7.74609 17.8125 8.4375 17.8125C9.12891 17.8125 9.73828 18.2637 9.9375 18.9316L10.6172 21.1934C11.0508 20.8301 11.6016 20.625 12.1875 20.625C13.1191 20.625 13.9688 21.1523 14.3848 21.9844L14.6426 22.5H17.8125C18.3281 22.5 18.75 22.9219 18.75 23.4375C18.75 23.9531 18.3281 24.375 17.8125 24.375H14.0625C13.7051 24.375 13.3828 24.1758 13.2246 23.8594L12.709 22.8223C12.6094 22.623 12.4102 22.5 12.1934 22.5C11.9766 22.5 11.7715 22.623 11.6777 22.8223L11.1621 23.8594C10.9922 24.2051 10.623 24.4102 10.2422 24.375C9.86133 24.3398 9.5332 24.0762 9.42773 23.7129L8.4375 20.4492L7.86328 22.3711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15175_56108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.5V30H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.cd3a966dba91d3867d52cf7eb18514b4.svg";
export { ForwardRef as ReactComponent };